var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAudacitySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e363a8",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.264 122.309c0-3.998.603-29.443.603-34.157 0-4.714 3.124-12.91 13-22.55 9.877-9.641 19.451-11.343 30.057-14.97 10.606-3.625 14.1-2.743 23.508-2.743 9.407 0 9.79-.342 23.76 3.533 13.97 3.875 23.794 10.105 31.89 17.047s7.9 13.254 9.522 19.46c1.62 6.208 1.62 21.313 1.62 34.157 12.556 11.611 14.366 17.133 14.366 38.821 0 21.689-11.056 37.037-18.988 42.863-7.933 5.825-4.441 4.586-9.018 5.078-4.577.491-9.639-3.075-9.639-3.075l-.183-80.164 7.312-4.511s.998-24.812.998-29.657c0-4.844-4.225-12.684-6.765-16.199-2.54-3.514-10.434-6.773-19.471-9.64-9.037-2.868-13.725-3.533-25.404-3.487-11.68.047-15.175.015-27.09 3.487-11.915 3.471-10.543 3.688-16.764 9.64-6.22 5.952-8.713 11.33-8.56 16.506.152 5.176.804 30.703.804 30.703l9.14 5.281-1.384 75.297s-3.958 4.19-8.408 4.86c-4.45.67-7.615-1.718-14.906-6.995-7.291-5.278-14.742-17.096-14.742-38.16 0-21.063.044-29.037 14.742-40.425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.731 155.314l7.613-23.496 15.719 45.975 12.555-62.277 10.81 62.45 15.869-45.726 9.202 22.975-.778 29.69-7.743-28.322-15.685 45.376-11.98-45.711-11.762 45.583-15.436-45.686-8.447 28.612z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAudacitySvgrepoCom);
export default __webpack_public_path__ + "static/media/logo-audacity-svgrepo-com.0104f18d84502ac73164cf7703a42b75.svg";
export { ForwardRef as ReactComponent };